import { getStore as getAppAuthUiStore } from 'owa-app-auth-ui-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isMsalFlowEnabled } from 'owa-msaljs/lib/isMsalFlowEnabled';

/**
 * Whether mail search is blocked because the user must sign in again. Once MSAL reports an
 * interaction-required failure, every token request returns nothing and every search request
 * fails with a 401 until the user signs in, so search is disabled instead.
 *
 * Matches the condition that shows the sign-in-required banner and dialog (showMsalAuthInfoBar,
 * MsalAuthDialog), so search is only disabled while the user is being told to sign in.
 */
export default function isSearchBlockedBySigninRequired(): boolean {
    return (
        isGlobalFeatureEnabled('sea-disableSearchOnSigninRequired') &&
        isMsalFlowEnabled() &&
        getAppAuthUiStore().isSignInRequired
    );
}
